/**
 * Contrats (modules `modeles-contrats` et `contrats-artistes`, M5).
 *
 * Les textes sont des GABARITS NEUTRES « modèle à faire valider » (décision
 * n° 11) : Artosera fournit la mécanique — champs de fusion, numérotation,
 * PDF —, jamais la rédaction juridique définitive.
 */
import { z } from 'zod';
export const GENRES_CONTRAT = ['nda', 'depot', 'artiste'];
export const genreContratSchema = z.enum(GENRES_CONTRAT);
export const ETATS_CONTRAT = ['genere', 'signe', 'annule'];
export const ETATS_CONTRAT_ARTISTE = ['brouillon', 'en_vigueur', 'resilie'];
/** Jalons de rappel par défaut d'un contrat d'artiste, en jours avant l'échéance. */
export const RAPPELS_CONTRAT_PAR_DEFAUT = [90, 30, 7];
/** Le catalogue FERMÉ des champs de fusion, et d'où vient leur valeur. */
export const CHAMPS_FUSION = {
    'galerie.raisonSociale': 'galerie',
    'galerie.adresse': 'galerie',
    'galerie.ville': 'galerie',
    'galerie.siren': 'galerie',
    'artiste.nom': 'artiste',
    'artiste.nationalite': 'artiste',
    'contact.nom': 'contact',
    'contact.adresse': 'contact',
    'oeuvres.liste': 'oeuvres',
    'contrat.numero': 'contrat',
    'contrat.date': 'contrat',
    'saisie.objet': 'saisie',
    'saisie.duree': 'saisie',
    'saisie.commission': 'saisie',
    'saisie.territoire': 'saisie',
    'saisie.exclusivite': 'saisie',
};
const GALERIE = [
    'galerie.raisonSociale',
    'galerie.adresse',
    'galerie.ville',
    'galerie.siren',
];
const CONTRAT = ['contrat.numero', 'contrat.date'];
/** Les champs qu'un genre admet. */
export const CHAMPS_PAR_GENRE = {
    nda: [...GALERIE, 'contact.nom', 'contact.adresse', ...CONTRAT, 'saisie.objet', 'saisie.duree'],
    depot: [
        ...GALERIE,
        'contact.nom',
        'contact.adresse',
        'oeuvres.liste',
        ...CONTRAT,
        'saisie.duree',
        'saisie.commission',
    ],
    artiste: [
        ...GALERIE,
        'artiste.nom',
        'artiste.nationalite',
        ...CONTRAT,
        'saisie.territoire',
        'saisie.duree',
        'saisie.exclusivite',
        'saisie.commission',
    ],
};
/** Les champs que la régie demande à la saisie (`saisie.*`). */
export const CHAMPS_SAISIS = Object.keys(CHAMPS_FUSION).filter((champ) => champ.startsWith('saisie.'));
export const MENTION_VALIDATION = {
    fr: 'Modèle à faire valider par un conseil avant tout usage.',
    en: 'Template to be reviewed by legal counsel before any use.',
};
const MOTIF_CHAMP = /\{\{\s*([^{}]*?)\s*\}\}/g;
/** Les champs cités par un texte, dans l'ordre, sans doublon. */
export function champsDuTexte(texte) {
    const vus = new Set();
    for (const trouve of texte.matchAll(MOTIF_CHAMP))
        if (trouve[1] !== undefined)
            vus.add(trouve[1].trim());
    return [...vus];
}
/** Les champs de ces textes que le genre n'admet pas (inconnus compris). */
export function champsHorsGenre(genre, textes) {
    const admis = new Set(CHAMPS_PAR_GENRE[genre]);
    return [...new Set(textes.flatMap(champsDuTexte))].filter((champ) => !admis.has(champ));
}
/** Remplace les champs connus ; laisse les autres tels quels et les liste. */
export function fusionner(texte, valeurs) {
    const manquants = new Set();
    const resultat = texte.replace(MOTIF_CHAMP, (brut, champ) => {
        champ = champ.trim();
        const valeur = Object.hasOwn(valeurs, champ) ? valeurs[champ] : undefined;
        if (valeur === undefined || valeur.trim() === '') {
            manquants.add(champ);
            return brut;
        }
        return valeur;
    });
    return { texte: resultat, manquants: [...manquants] };
}
//# sourceMappingURL=contracts.js.map